import React, { useState, useEffect, forwardRef, useRef, Fragment } from "react";
import { Button } from '../../components/Wrappers'
import { TextField, InputAdornment,
         FormControl, InputLabel, Select, Input, Chip, MenuItem,
         NativeSelect} from "@material-ui/core";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// components
import SelectCustomer from '../../components/Customer/SelectCustomer';

// Icons
import {
    CalendarToday as CalendarTodayIcon,
    HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";
import "./Workload.css";

registerLocale('en-NZ', enNZ);


const Workload = forwardRef((props, ref) => {
    var classes = useStyles();
    var { regions } = useUserState();
    const fromRef = useRef(null);
    const fromCalendarRef = useRef(null);
    const [selectedFrom, setSelectedFrom] = React.useState(null);
    const [fromFocused, setFromFocused] = React.useState(false);
    const toRef = useRef(null);
    const toCalendarRef = useRef(null);
    const [selectedTo, setSelectedTo] = React.useState(null);
    const [toFocused, setToFocused] = React.useState(false);
    var currentFromValue = null;
    var currentToValue = null;
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [regionSelectionOpen, setRegionSelectionOpen] = React.useState(false);
    const [selectedIsAll, setSelectedIsAll] = React.useState('YES');
    const [selectedIsAllCustomers, setSelectedIsAllCustomers] = useState('YES');
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [selectedCustomerId, setSelectedCustomerId] = useState(-1);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    /*useEffect(() => {
      if (fromCalendarRef !== undefined && fromCalendarRef !== null &&
        fromCalendarRef.current !== undefined && fromCalendarRef.current !== null) {
        fromCalendarRef.current.setOpen(fromFocused);
      }
    },[fromFocused]);*/

    useEffect(() => {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      setSelectedFrom(firstDay);
      setSelectedTo(lastDay);
    },[]);

    const handleChange = (event) => {
        setSelectedRegions(event.target.value);
    };

    const handleDelete = (id) => {
      const updatedRegions = selectedRegions.filter(item => item.id !== parseInt(id));
      setSelectedRegions(updatedRegions);
    };

    const onMouseDown = e => {
      e.stopPropagation();
    };

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeFrom(d) {
      currentFromValue = d;
    }

    function handleChangeTo(d) {
      currentToValue = d;
    }

    function onFocusFrom(event) {
      setFromFocused(true);
    }

    function onFocusTo(event) {
      setToFocused(true);
    }

    function blurFrom(event) {
      setFromFocused(false);
    }

    function blurTo(event) {
      setToFocused(false);
    }

    function handleSelectFrom(d) {
      setSelectedFrom(d);
    }

    function handleSelectTo(d) {
      setSelectedTo(d);
    }

    // triggered if use keyboard
    function handleFromKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setFromFocused(false);
      }
    }

    function handleToKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setToFocused(false);
      }
    }

    function handleChangeIsAll(e) {
      setSelectedIsAll(e.target.value);
      if (e.target.value === 'YES') {
        setSelectedRegions([]);
      }
    }

    function generateWorkloadReport() {
      var from = selectedFrom;
      var to = selectedTo;

      if (from === undefined || from === null || to === undefined || to === null) {
          var date = new Date()
          var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
          from = firstDay;
          to = lastDay;
      }

      let [f_date, f_month, f_year] = from.toLocaleDateString('en-NZ').split("/");
      let [t_date, t_month, t_year] = to.toLocaleDateString('en-NZ').split("/");

      let regionIds = selectedRegions === undefined || selectedRegions === null || selectedRegions.length > 0 ?
              selectedRegions.map(service => service.id).toString() : '';
      console.log(`${config.clientApi}/reports/customers_workload?&active=true&customer_id=${selectedCustomerId}&from=${f_year}-${f_month}-${f_date}&to=${t_year}-${t_month}-${t_date}${regionIds === undefined || regionIds === null || regionIds === '' ? '' : `&regionIds=${regionIds}`}`,);
      window.open(
          `${config.clientApi}/reports/customers_workload?&active=true&customer_id=${selectedCustomerId}&from=${f_year}-${f_month}-${f_date}&to=${t_year}-${t_month}-${t_date}${regionIds === undefined || regionIds === null || regionIds === '' ? '' : `&regionIds=${regionIds}`}`,
          '_blank'
      );
    }


    function handleChangeIsAllCustomers(e) {
      setSelectedIsAllCustomers(e.target.value);
      if (e.target.value === 'YES') {
        setSelectedCustomer(undefined);
        setSelectedCustomerId(-1);
      }
    }

    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
      setSelectedCustomerId(customer !== null && customer !== undefined ? customer.id : -1);
    }

    function onSelectCustomerFormUpdated(isValid) {

    }


    return (
      <>

                <div className={classes.reportCalendars}>
                    <TextField
                      id="from"
                      ref={fromRef}
                      label="From"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: fromFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={fromCalendarRef}
                          className={classes.textField}
                          selected={selectedFrom}
                          onChange={handleChangeFrom}
                          onFocus={onFocusFrom}
                          onSelect={handleSelectFrom}
                          onClickOutside={blurFrom}
                          onKeyDown={handleFromKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                    />
                    <TextField
                      id="to"
                      ref={toRef}
                      label="To"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: toFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={toCalendarRef}
                          className={classes.textField}
                          selected={selectedTo}
                          onChange={handleChangeTo}
                          onFocus={onFocusTo}
                          onSelect={handleSelectTo}
                          onClickOutside={blurTo}
                          onKeyDown={handleToKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                    />

                </div>

                <FormControl variant="outlined" className={classnames({
                      'isAllRegionsSelect':  true,
                      'workload-select-control': true
                    })}>
                  <InputLabel id="is_all">All Regions?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAll}
                      onChange={handleChangeIsAll}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAll === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.regions, {
                              'regions-control': true
                            })}>
                  <InputLabel id="regions-label">Regions</InputLabel>
                  <div className={classnames(classes.regionsInput, {
                                'regions-control-input': true
                              })}>
                  <InputAdornment position="start">
                    <HomeWorkIcon />
                  </InputAdornment>
                  <Select
                    labelId="regions-label"
                    id="regions"
                    multiple
                    className={classes.regionsSelect}
                    value={selectedRegions}
                    onChange={handleChange}
                    open={regionSelectionOpen}
                    onClose={() => {setRegionSelectionOpen(false);}}
                    onOpen={() => {setRegionSelectionOpen(true);}}
                    input={<Input id="region-chip" />}
                    renderValue={(selected) => (
                      <div className={classes.chips}>
                        {selected.map((value) => {
                          return (
                            <Fragment key={value.id || value}>
                                <Chip label={value.name || regions.filter(item => item.id === value)[0].name}
                                      className={classes.chip}
                                      onDelete={() => handleDelete(`${value.id}`)}
                                      variant="outlined"
                                      onMouseDown={onMouseDown}/>
                              </Fragment>
                        );
                      })}
                      </div>
                    )}
                    MenuProps={MenuProps}
                    size="small"
                  >
                    {regions !== undefined && regions !== null &&
                      regions.length > 0 &&
                      regions.map((region, index) => (
                           <MenuItem key={region.id} value={region}
                              disabled={selectedRegions.filter(item => item !== undefined && item !== null && (item.id === region.id || item === region.id)).length === 1}
                              onClick={() => {setRegionSelectionOpen(false);}}>
                              <span className="dropdown-avatar">{region.name}</span>
                           </MenuItem>
                    ))}
                  </Select>
                  </div>
                </FormControl>}

                <FormControl variant="outlined"
                             style={{ marginBottom: 20 }}
                             className={classnames({
                      'isAllCustomersSelect':  true,
                      'overdue-select-control': true
                    })}>
                  <InputLabel id="is_all_customer">All Customers?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAllCustomers}
                      onChange={handleChangeIsAllCustomers}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAllCustomers === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.customers, {
                              'regions-control': true,
                              'customers-control': true,
                            })}>
                      <SelectCustomer labelName="Type to Search and Select Customer"
                                        selectedCustomer={selectedCustomer}
                                        onSelect={onSelectCustomer}
                                        onFormUpdated={onSelectCustomerFormUpdated}/>
                </FormControl>}

                <div className={classes.layoutButtonsRow}>
                    <Button onClick={generateWorkloadReport} >
                      <span>create</span>
                    </Button>
                </div>

      </>
    );
});

export default Workload;
